import React, { useState } from 'react';
import './CookieConsent.css';

const CookieConsent = ({ onAccept, onReject, isLoggedIn }) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="cookie-consent-container">
      <div className="cookie-consent-content">
        <div className="cookie-header">
          <h3>Cookie Consent</h3>
          <button 
            className="details-toggle" 
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? 'Hide Details' : 'Show Details'}
          </button>
        </div>
        
        <div className="cookie-main-message">
          <p>
            We use cookies to enhance your experience, analyze site traffic, and for marketing purposes. 
            {isLoggedIn && (
              <strong> By accepting, we'll also save your profile information (email, phone, and delivery address) for a better shopping experience.</strong>
            )}
          </p>
        </div>
        
        {showDetails && (
          <div className="cookie-details">
            <h4>Types of cookies we use:</h4>
            <ul>
              <li>
                <strong>Essential cookies:</strong> These cookies are necessary for the website to function properly.
              </li>
              <li>
                <strong>Analytics cookies:</strong> These help us understand how visitors interact with our website.
              </li>
              <li>
                <strong>Marketing cookies:</strong> These cookies track your online activity to help advertisers deliver more relevant advertising.
              </li>
              <li>
                <strong>Preference cookies:</strong> These cookies remember your settings and preferences.
              </li>
              {isLoggedIn && (
                <li>
                  <strong>User profile cookies:</strong> When you're logged in, we store your email, phone number, and delivery address to provide faster checkout and personalized services.
                </li>
              )}
            </ul>
            <p>
              Your data is handled in accordance with our <a href="/privacy-policy">Privacy Policy</a>. 
              You can change your cookie settings at any time by visiting the cookie preferences in the footer.
            </p>
          </div>
        )}
        
        <div className="cookie-actions">
          <button className="cookie-accept" onClick={onAccept}>
            Accept All Cookies
          </button>
          <button className="cookie-reject" onClick={onReject}>
            Reject Non-Essential
          </button>
          <button className="cookie-preferences" onClick={() => window.location.href = '/privacy-policy'}>
            Cookie Preferences
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;